import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { Period } from "@/shared/domain/metrics";

dayjs.extend(utc);

/**
 * Human-readable title for an aggregated bucket, used in chart-card
 * drill-down tables. Format depends on the period:
 * - daily      → "March 31, 2026"
 * - weekly     → "Apr 01 - Apr 07, 2026" (same year) or with both years (cross-year)
 * - monthly    → "March 2026"
 * - quarterly  → "26Q1"
 * - yearly     → "2026"
 */
export function getDrillDownTitle(
  startTime: string,
  endTime: string,
  period: Period,
): string {
  const start = dayjs.utc(startTime);
  const end = dayjs.utc(endTime);

  switch (period) {
    case "daily":
      return start.format("MMMM DD, YYYY");
    case "weekly":
      if (start.year() === end.year()) {
        return `${start.format("MMM DD")} - ${end.format("MMM DD, YYYY")}`;
      }
      return `${start.format("MMM DD, YYYY")} - ${end.format("MMM DD, YYYY")}`;
    case "monthly":
      return start.format("MMMM YYYY");
    case "quarterly":
      return `${start.format("YY")}Q${Math.floor(start.month() / 3) + 1}`;
    case "yearly":
      return start.format("YYYY");
    default:
      return start.format("MMM DD, YYYY");
  }
}
